<template>
  <v-container fluid>
    <v-card class="text-h5 text-center" flat>{{ title }}</v-card>
    <Plotly
      :data="traces"
      :layout="mergedLayout"
      :displaylogo="false"
      @restyle="evt => $emit('restyle', evt)"
    />
  </v-container>
</template>

<script>
import _ from 'lodash'
import { getBaseLayout } from '@/helpers/graph-helper'
import { Plotly } from 'vue-plotly'

export default {
  components: {
    Plotly
  },
  props: {
    defaultRange: { type: Array, default: null },
    defaultRangeSize: { type: Number, default: null },
    graphType: { type: String, default: null },
    layout: { type: Object, default: () => {} },
    title: { type: String, default: null },
    traces: { type: Array, required: true }
  },
  computed: {
    mergedLayout() {
      return _.merge(
        {
          margin: {
            //Changing the rangeslider selected area can cause the legend to overlap the title
            //when changing the rangeslider selection causes the x axis labels to resize
            //(for example, when the labels go from displaying at an angle to completely vertical)
            //so handling the title manually and overriding the margin to remove plotly's title area
            t: 50
          },
          legend: {
            orientation: 'h',
            y: 1.3,
            xanchor: 'center',
            x: 0.5,
            traceorder: 'normal'
          },
          modebar: {
            orientation: 'v'
          },
          xaxis: this.xaxis
        },
        getBaseLayout(this.graphType),
        this.layout
      )
    },
    tracesSize() {
      return _.head(this.traces).x.length
    },
    xaxis() {
      let rangeStart = 0
      let rangeEnd = this.tracesSize > 0 ? _.subtract(this.tracesSize, 1) : 0
      if (!_.isNil(this.defaultRange)) {
        rangeStart = this.defaultRange[0]
        rangeEnd = this.defaultRange[1]
      } else if (this.defaultRangeSize && this.tracesSize > this.defaultRangeSize) {
        rangeStart = _.subtract(this.tracesSize, this.defaultRangeSize)
      }
      return this.tracesSize > 0
        ? {
            range: [rangeStart, rangeEnd],
            type: 'category',
            rangeslider: { range: [0, rangeEnd] }
          }
        : {}
    }
  }
}
</script>
